export class DeathVeil {
  shown = false;
  private readonly el: HTMLElement;

  constructor(private readonly onStand: () => void) {
    this.el = ensureVeil();
    this.el.addEventListener('click', this.onClick);
  }

  show(reason?: string): void {
    if (this.shown) {
      return;
    }
    this.shown = true;
    const copy = this.el.querySelector('.death-reason');
    if (copy) {
      copy.textContent = reason ?? 'You lost consciousness on Vesper Cay.';
    }
    this.el.hidden = false;
    this.el.removeAttribute('hidden');
    document.exitPointerLock?.();
  }

  hide(): void {
    this.shown = false;
    this.el.hidden = true;
  }

  private readonly onClick = (event: Event): void => {
    event.preventDefault();
    event.stopPropagation();
    if (this.shown) {
      this.onStand();
    }
  };
}

function ensureVeil(): HTMLElement {
  const existing = document.getElementById('death-veil');
  if (existing) {
    return existing;
  }
  const host = document.body;
  const veil = document.createElement('div');
  veil.id = 'death-veil';
  veil.hidden = true;
  veil.setAttribute('role', 'dialog');
  veil.setAttribute('aria-label', 'You blacked out');

  const title = document.createElement('p');
  title.className = 'death-title';
  title.textContent = 'You blacked out';

  const reason = document.createElement('p');
  reason.className = 'death-reason';
  reason.textContent = '';

  const hint = document.createElement('p');
  hint.className = 'death-hint';
  hint.textContent = 'Click to stand';

  veil.append(title, reason, hint);
  host.append(veil);
  return veil;
}
